'use strict';

const MILLISECONDS_PER_SECOND = 1000;
const MILLISECONDS_PER_MINUTE = 60 * 1000;
const MILLISECONDS_PER_HOUR = 3600 * 1000;
const MILLISECONDS_PER_DAY = 24 * 3600 * 1000;

export default angular
  .module('maestro.filters.calculateTime', [])

  .filter('calculateTime', function() {
    return function(value) {
      let count = 1,
        unit = 'seconds';
      if (!value) {
        return {
          count: count,
          unit: unit
        };
      }
      let connectedDate = new Date(value);
      let nowDate = new Date();
      let time = nowDate.getTime() - connectedDate.getTime();
      if (time > MILLISECONDS_PER_DAY) {
        count = Math.ceil(time / MILLISECONDS_PER_DAY);
        unit = 'day';
      } else if (time > MILLISECONDS_PER_HOUR) {
        count = Math.ceil(time / MILLISECONDS_PER_HOUR);
        unit = 'hour';
      } else if (time > MILLISECONDS_PER_MINUTE) {
        count = Math.ceil(time / MILLISECONDS_PER_MINUTE);
        unit = 'minute';
      } else if (time > MILLISECONDS_PER_SECOND) {
        count = Math.ceil(time / MILLISECONDS_PER_SECOND);
        unit = 'second';
      }
      return {
        count: count,
        unit: unit
      };
    };
  })

  .name;
